import { render, staticRenderFns } from "./DatatableTechnologicalDevelopmentsCategory.vue?vue&type=template&id=4c3d69b5&scoped=true&"
import script from "./DatatableTechnologicalDevelopmentsCategory.vue?vue&type=script&lang=js&"
export * from "./DatatableTechnologicalDevelopmentsCategory.vue?vue&type=script&lang=js&"
import style0 from "./DatatableTechnologicalDevelopmentsCategory.vue?vue&type=style&index=0&id=4c3d69b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3d69b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
